/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, BASE_URL, PORTS, SERVICES, PATH_EXTENSION,
} from '@/middlewares/httpClient';

const key: string = 'userservice';
const port: string = PORTS.get(key);
const service: string = SERVICES.get(key);

const END_POINT_MANAGER: string = `${BASE_URL}:${port}${PATH_EXTENSION}/${service}`;

const inviteNewUser = (email: string) => httpClient.post(`${END_POINT_MANAGER}/invite?email=${email}`);

export {
  inviteNewUser,
};
